import cn from 'classnames';
import React from 'react';

import { useTranslation } from 'client/hooks';

import css from './TermsFooter.module.scss';

interface Props {
  className?: string;
}

export const TermsFooter: React.FC<Props> = (props) => {
  const { className = '' } = props;
  const { translate } = useTranslation('termsFooter');

  return (
    <div className={cn(css.termsFooter, className)}>
      <a href="https://z.ynet.co.il/short/content/2018/privacypolicy/policy.html" target="_blank" rel="noreferrer">
        {translate('terms')}
      </a>
      <a href="https://z.ynet.co.il/short/content/2018/privacypolicy/terms.html" target="_blank" rel="noreferrer">
        {translate('conditions')}
      </a>
      <a href="mailto:audiochat@ynet.co.il" target="_blank" rel="noreferrer">
        {translate('contactUs')}
      </a>
    </div>
  );
};
